var moment = require('moment');
var module = angular.module('octopusApp.tasks');

module.directive('activityElementSummary', function (octoUtil) {
  var summaryTemplate = '<div class="log-entry">' +
          '<div class="log-progress"></div>' +
          ' <span class="log-title title" title="view log"></span>' +
          ' <div class="log-content">' +
          '   <p class="log-additional"><span>84</span> additional lines have been hidden. <a href="">Show all</a></p>' +
          '   <div class="log-output fixed"></div>' +
          '   <div class="log-entry-children"></div>' +
          ' </div>' +
          '</div>';

  var detailsTemplate = '<div class="log-entry">' +
          '<div class="log-entry-heading">' +
          ' <div class="log-progress pull-right"></div>' +
          ' <a href="" class="log-entry-title">' +
          '   <i class="fa fa-fw"></i>' +
          '   <span class="log-title title" title="view log"></span>' +
          ' </a>' +
          '</div>' +
          '<div class="log-content padding-xs-vr">' +
          ' <p class="log-additional"><span>84</span> additional lines have been hidden. <a href="">Show all</a></p>' +
          ' <div class="log-output fixed"></div>' +
          ' <div class="log-entry-children"></div>' +
          ' </div>' +
          '</div>';

  var summaryMode = (function () {
    return {
      className: 'log-entry-summary',
      template: summaryTemplate,
      expandable: false,
      nodeFilter: function (element) {
        return element.showAtSummaryLevel;
      },
      logEntryFilter: function (logEntry) {
        return logEntry.Category === "Warn" ||
            logEntry.Category === "Warning" ||
            logEntry.Category === "Fatal" ||
            logEntry.Category === "Alert" ||
            logEntry.Category === "Error" ||
            logEntry.MessageText.indexOf("Submitted by: ") === 0;
      }
    };
  })();

  var detailsMode = (function () {
    return {
      className: 'log-entry-details',
      template: detailsTemplate,
      expandable: true,
      nodeFilter: function (element) {
        return element.status !== 'Skipped' && element.status !== 'Pending';
      },
      logEntryFilter: function (logEntry) {
        return true;
      }
    };
  })();

  var modes = { 'summary': summaryMode, 'details': detailsMode };

  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      element: '=',
      goToLog: '=',
      toggleGap: '=',
      mode: '@'
    },
    terminal: true,
    link: function (scope, element) {
      var elementNodes = {};

      var mode = modes[scope.mode];

      var ensureViewNode = function (node, parentDomElement) {
        if (!node.id) {
          return { update: function() {} };
        }
        if (elementNodes[node.id]) {
          return elementNodes[node.id];
        }

        if (!mode.nodeFilter(node)) {
          return { update: function() {} };
        }

        var self = {};
        self.node = node;
        self.domElement = angular.element(mode.template);

        self.childrenElement = $(".log-entry-children", self.domElement);
        self.expandElement = $(".fa-fw", self.domElement);
        self.logOutputElement = $(".log-output", self.domElement);
        self.logAdditionalElement = $(".log-additional", self.domElement);
        self.logAdditionalCountElement = $(".log-additional span", self.domElement);
        self.titleElement = $(".title", self.domElement);
        self.contentElement = $(".log-content", self.domElement);
        self.progressElement = $(".log-progress", self.domElement);
        self.rendered = false;
        self.lastVersion = -1;
        if (mode.expandable) {
          self.titleElement.addClass("expandable");
        }
        self.renderLog = function() {
          if (self.lastVersion === node.counter && self.rendered) {
            return;
          }
          self.lastVersion = node.counter;

          if (node.isExpanded || !mode.expandable) {
            var html = [];
            var logElements = node.logElements;
            for (var i = 0; i < logElements.length; i++) {
              var logEntry = logElements[i];
              if (!mode.logEntryFilter(logEntry)) {
                continue;
              }
              var occurred = moment(logEntry.OccurredAt);

              html.push('<div class="log-line ');
              html.push(logEntry.Category);
              html.push('">');

              if(logEntry.Category === "Gap") {
                html.push('<a href="" class="toggleGap">');
                html.push(octoUtil.escapeHtml(logEntry.DetailedMessageText));
                html.push('</a>');
              } else {
                html.push('<div class="log-time" title="');
                html.push(occurred.format("LLLL"));
                html.push('">');
                html.push(occurred.format("MMMM Do YYYY HH:mm:ss"));
                html.push('</div>');

                html.push('<div class="log-category">');
                html.push(logEntry.Category);
                html.push('</div>');

                html.push('<div class="log-message">');
                html.push(octoUtil.escapeHtml(logEntry.DetailedMessageText));
                html.push('</div>');
              }
              html.push('</div>');
            }
            self.rendered = true;
            self.logOutputElement.html(html.join(''));

            $(".toggleGap", self.logOutputElement).click(function (e) {
              e.preventDefault();
              scope.$apply(function () {
                scope.toggleGap(node);
              });
              return false;
            });
          } else {
            self.rendered = false;
          }
        };

        $(".title", self.domElement).parent().click(function (e) {
          e.preventDefault();
          scope.$apply(function () {
            if (mode.expandable) {
              node.toggleExpanded();
              self.update();
            } else {
              scope.goToLog(node);
            }
          });
          return false;
        });

        parentDomElement.append(self.domElement);

        self.update = function () {
          if (!mode.nodeFilter(node)) {
            self.domElement.hide();
          } else {
            self.domElement.show();
          }

          self.titleElement.text(node.name);
          self.domElement.attr("class", "log-entry " + node.status +" "+ mode.className);

          if (mode.expandable) {
            if (node.isExpanded) {
              self.expandElement.removeClass("fa-plus-square").addClass("fa-minus-square");
            } else {
              self.expandElement.removeClass("fa-minus-square").addClass("fa-plus-square");
            }
          }

          self.renderLog();

          if (node.progressPercentage > 0) {
            self.progressElement.show();
            self.progressElement.html("<div class='progress progress-striped active'><div class='progress-bar' style='width: " + node.progressPercentage + "%'></div></div> <span class='log-progress-text'>" + octoUtil.escapeHtml(node.progressMessage) +  " (" + node.progressPercentage + "%)</span>");
          } else {
            self.progressElement.html('');
            self.progressElement.hide();
          }

          if (node.additionalEntries > 0) {
            self.logAdditionalElement.show();
            self.logAdditionalCountElement.html(node.additionalEntries.toFixed(0).replace(/(\d)(?=(\d{3})+\b)/g,'$1,'));
          } else {
            self.logAdditionalElement.hide();
          }

          if (mode.expandable) {
            if (node.isExpanded) {
              self.contentElement.show();
            } else {
              self.contentElement.hide();
            }
          }

          for (var i = 0; i < self.node.children.length; i++) {
            ensureViewNode(self.node.children[i], self.childrenElement).update();
          }
        };

        elementNodes[node.id] = self;
        return self;
      };

      var render = function() {
        if (!scope.element) {
          return;
        }

        ensureViewNode(scope.element, element).update();
      };

      scope.$watch("element.updateCount", function () {
        render();
      });
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/directives/activity_element_summary.js
// module id = 615
// module chunks = 1